const printSize = {
  A3: { height: 42, width: 30 },
  A4: { height: 30, width: 21 },
  A5: { height: 21, width: 15 },
};
export default printSize;
